export default __webpack_public_path__ + "static/media/icon1.1a608676.svg";